import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", { class: "text-center font-weight-bold text-404" }, "No applications to display", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "font-weight-bold text-h5 text-center" }, "This user does not have any applications assigned.", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createBlock(_component_v_row, {
    "no-gutters": "",
    class: "fill-height",
    justify: "center"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_col, {
        cols: "12",
        class: "d-flex justify-center fill-height"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, {
            justify: "center",
            align: "center",
            "no-gutters": ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { class: "mx-auto" }, {
                default: _withCtx(() => [
                  _hoisted_1,
                  _hoisted_2
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, { cols: "12" })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}